<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<contact v-if='item.Property.Control=="Condition"' :data-val="item"></contact>
			<dates v-if='item.Property.Control=="Date"' :data-val="item"></dates>
			<digit v-if='item.Property.Control=="Number"' :data-val='item'></digit>
			<file v-if='item.Property.Control=="File"' :data-val="item"></file>
			<money v-if='item.Property.Control=="Money"' :data-val="item"></money>
			<selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></selector>
			<tables v-if='item.Property.Control=="Table"' :data-val='item'></tables>
			<textArea v-if='item.Property.Control=="Textarea"' :data-val='item'></textArea>
			<tips v-if='item.Property.Control=="Tips"' :data-val="item"></tips>
			<version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></version>
		</div>
		<List :data-val="valData" @child-event='getListVal'></List>
		<CustomTree></CustomTree>
		
		<Button class="submit-process" v-on:click='submit' size="large" type="primary"> 提交 </Button>
		
		<Spin size="large" fix v-if="spinShow"></Spin>
	</div>
</template>

<script>
	// import {
	// 	initWxConfig
	// } from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";
	import List from '../components/List.vue';
	import CustomTree from "../components/CustomTree.vue";

	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	var logInfo = null;

	var isSubmit = false;
	
	import {
			formatDate
		} from '@/utils/date'

	export default {
		components: {
			List,
			CustomTree
		},
		data() {
			return {
				"templateData": templateData,
				"fromData": [],
				spinShow: true,
				flowId:null,
				valData: {
					listTitle: [{
							type: 'selection',
							width: 45,
							align: 'center',
							fixed: 'left'
						},
						{
							title: '电话号码',
							key: 'telephone',
							width: 120,
							disabled: true
						},
						{
							title: '昵称',
							key: 'nickname',
							width: 120,
							disabled: true
						},
						{
							title: '时间',
							key: 'time',
							width: 120,
							disabled: true
						},


					],
					listData: [{
							telephone: '023-1-1-034805',
							nickname: '小1',
							time: '2019/7/23  12:03:14',
							_checked: false
						},
						{
							telephone: '023-1-1-034805',
							nickname: '小2',
							time: '2019/7/23  12:03:14',
							_checked: false
						},
						{
							telephone: '023-1-1-034805',
							nickname: '小3',
							time: '2019/7/23  12:03:14',
							_checked: false
						},
						{
							telephone: '023-1-1-034805',
							nickname: '小4',
							time: '2019/7/23  12:03:14',
							_checked: false
						},

					]
				},
				
			}
		},
		mounted() { //页面挂载
			// initWxConfig(this);
			this.getTemplate();
		},
		methods: { //方法
			getTemplate() {
				let that = this;
				console.log(this.$configure.logInfo);

				// console.log(stringUtils.GetQueryString("templateId"))
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(res => {
					console.log(res)
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.JobLevel <= 6 ? 1 : 2;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "原职位") {
							that.templateData.TemplateContent.Controls[i].Value = "新进置业顾问1-1";
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "晋升职位") {
							that.templateData.TemplateContent.Controls[i].Value = "置业顾问2-1";
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "晋升说明") {
							that.templateData.TemplateContent.Controls[i].Value =
								`1、若当月入库，当月申请，审批完成时间为当月29号(2月为27号)18:00点前，新职位生效时间为入库当日。
2、若当月入库，当月申请，审批完成时间超过当月29号(2月为27号)18:00点，新职位生效时间为次月1号。
3、若当月入库，跨月申请，审批完成时间为申请当月29号(2月为27号)18:00点前，新职位生效时间为当月1号。
4、若当月入库，跨月申请，审批完成时间超过申请当月29号(2月为27号)18:00，新职位生效时间为申请次月1号。`;
						}
					}

					that.spinShow = false;
				}, err => {
					console.log(err)
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val) {
				var templateId = stringUtils.GetQueryString("templateId");
				var controls = this.templateData.TemplateContent.Controls;
				var i = 0;
				if (templateId == 'Bs7xbzNAeeBPD3ttT37HHJRe4KRc3bA5wURd7xTME') {
					// 是员工人事类盖章审批申请
					if (val == 'option-1595832288661' || val == 'option-1595832288662' || val == 'option-1595832288663') {
						for (i = 0; i < controls.length; i++) {
							if (controls[i].Property.Title[0].Text == '附件') {
								controls[i].Property.Require = 1;
								return;
							}
						}
					} else {
						for (i = 0; i < controls.length; i++) {
							if (controls[i].Property.Title[0].Text == '附件') {
								controls[i].Property.Require = 0;
								return;
							}
						}
					}
				}
			},
			submit() {
				let that = this;
				if (isSubmit) {
					that.$message.info("已提交");
					return;
				}
				isSubmit = true;
				var controls = that.templateData.TemplateContent.Controls;
				var index = -1;
				var tableData = [];
				for (var i = 0; i < controls.length; i++) {
					if (controls[i].Property != null && controls[i].Property.Require == 1 && (controls[i].Value == null && controls[i]
							.Values == null)) {
						alert(controls[i].Property.Title[0].Text + "未填写,请填写完整");
						isSubmit = false;
						return;
					}
					if (controls[i].Property.Title[0].Text == "申请内容") {
						tableData = this.convertInTable(this.fromData, controls[i]);
						console.log(tableData);
						index = i;
					}
				}
				if (index != -1) {
					controls.splice(index, 1);
					for (var k = 0; k < tableData.length; k++) {
						controls.splice(index + k, 0, tableData[k]);
					}
				}

				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					console.log(res);
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {
						that.$message.error(res.data.ErrMsg);
					}
				}, err => {
					console.log(err)
				})
			},
			getListVal(data, type) {
				if ("search" == type) {
					console.log("搜索:" + data)
				} else if ("changePages" == type) {
					console.log("翻页:" + data)
				} else if ("changeData" == type) {
					this.fromData = data;
				}

			},
			
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
